var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVioletNoise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8999 8.5249L8.8999 13.4249M8.8999 47.7249L8.8999 42.8249M18.6999 8.5249V13.4249V18.3249M28.4999 8.5249V13.4249V18.3249M28.4999 47.7249V42.8249M38.2999 8.5249V13.4249V18.3249V23.2249M38.2999 47.7249V42.8249V37.9249V33.0249M18.6999 28.1249V33.0249V37.9249V47.7249M28.4999 25.9471V35.2027M48.0999 21.5916V8.5249M48.0999 30.3027V35.2027M8.8999 33.0249L8.8999 28.1249L8.8999 23.2249M48.0999 42.8249V47.7249",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1001 30.303V35.203",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3 8.5249V13.4249V18.3249V23.2249",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8999 33.0251L8.8999 28.1251L8.8999 23.2251",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 47.725V42.825",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 8.5249V13.4249V18.3249",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVioletNoise);
export default __webpack_public_path__ + "static/media/violet_noise.7e987f390933e16889895fa70601dde3.svg";
export { ForwardRef as ReactComponent };